import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mx-auto flex min-h-[60vh] max-w-[1280px] flex-col items-center justify-center px-4 py-20 text-center md:px-6">
      <p className="font-heading text-[80px] font-bold leading-none text-primary-100 md:text-[120px]">404</p>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">页面走丢了</h1>
      <p className="mt-2 text-sm text-foreground-600">
        你访问的页面不存在或已被移除，不如回首页继续发现好电影吧。
      </p>
      <div className="mt-7 flex flex-wrap justify-center gap-3">
        <Link to="/" className="rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap">
          返回首页
        </Link>
        <Link to="/news" className="rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700 whitespace-nowrap">
          查看影视资讯
        </Link>
      </div>
    </div>
  );
}